<template>
  <keep-alive>
    <router-view id="content"/>
  </keep-alive>
</template>

<script>
  export default {
    name: "App",
  };
</script>

<style>
</style>